<app-title-bar rootBreadCrumbs="['i18n.core.navigation.reports']" titleText="i18n.domain.reports.automatic-parking.title"></app-title-bar>
<div class="row">
  <app-automatic-parking-form class="col" [form]="filterForm" (searchDTOChanged)="searchReports()"></app-automatic-parking-form>
</div>
@if (filterForm.controls.startDate.value && filterForm.controls.endDate.value) {
  <ejs-grid #grid
            class="grid-with-footer"
            width="100%"
            rowHeight="38"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [dataSource]="data">
    <e-columns>
      <e-column field="firstEntryDateTime"
                headerText="{{'i18n.domain.reports.automatic-parking.grid.firstEntryDateTime' | translate}}"
                type="date"
                format="dd.MM.yyyy HH:mm:ss"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="lastEntryDateTime"
                headerText="{{'i18n.domain.reports.automatic-parking.grid.lastEntryDateTime' | translate}}"
                type="date"
                format="dd.MM.yyyy HH:mm:ss"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="client.id"
                headerText="{{'i18n.domain.reports.automatic-parking.grid.clientId' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="client.name"
                headerText="{{'i18n.domain.reports.automatic-parking.grid.clientName' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="registeredZone.id"
                headerText="{{'i18n.domain.reports.automatic-parking.grid.zoneId' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="registeredZone.name"
                headerText="{{'i18n.domain.reports.automatic-parking.grid.zoneName' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="knownTag.parker.id"
                headerText="{{'i18n.domain.reports.automatic-parking.grid.parkerId' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="parker.firstName"
                headerText="{{'i18n.domain.reports.automatic-parking.grid.pakerName' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template
                     let-data>
          {{data.knownTag?.parker?.firstName}} {{data.knownTag?.parker?.lastName}}
        </ng-template>
      </e-column>
    </e-columns>
  </ejs-grid>
  <app-reports-footer (saveClicked)="saveReport($event)" [hideFileTypeSelector]="true"></app-reports-footer>
}

